<template>
  <div>
    <template v-if="!wapShow">
      <header1 :menuIndex="8"></header1>
      <div class="contactUs-banner">
        <div class="app-content">
          <div class="news-title">携手交达 共创未来</div>
          <div class="news-detail">交达在公路、铁路、市政、水利、矿山、地产等基建行业，提供特色检（监）测、特殊试验、科研项目、产品研发、技术咨询、数据服务、技术培训等类型的相关业务</div>
        </div>
      </div>
      <div class="contactUs-box1">
        <div class="app-content">
          <p class="box1-title">联系我们</p>
          <div class="box-content">
            <div class="p1">合作热线</div>
            <div class="flex p2"><i class="iconfont icon-a-Contactus-phone"
                                    style="font-size: 30px;color:#0071EF"></i><span style="margin-left: 42px">023-62296708</span><span style="margin-left: 42px">方宗平:18008377259</span>
            </div>
          </div>
        </div>

      </div>
      <div class="contactUs-box2 flex-center">
        <div class="app-content flex-sp">
          <div class="box2-li flex">
            <div class="li-left"></div>
            <div class="li-right">
            <span class="t1"><i class="iconfont icon-a-Contactus-Address" style="font-size: 30px;color:#0071EF;
    margin-right: 20px;"></i>地址</span>
              <span class="line"></span>
              <span class="t2">重庆市渝北区杨柳路2号B区3楼</span>
            </div>
          </div>
          <div class="box2-li flex">
            <div class="li-left"></div>
            <div class="li-right">
            <span class="t1"><i class="iconfont icon-a-Contactus-Website" style="font-size: 30px;color:#0071EF;
    margin-right: 20px;"></i>网址</span>
              <span class="line"></span>
              <a href="https://www.scjdst.com/" class="t2">www.scjdst.com</a>
            </div>
          </div>
          <div class="box2-li flex">
            <div class="li-left"></div>
            <div class="li-right">
            <span class="t1"><i class="iconfont icon-a-Contactus-email" style="font-size: 30px;color:#0071EF;
    margin-right: 20px;"></i>邮编</span>
              <span class="line"></span>
              <span class="t2">401120</span>
            </div>
          </div>
        </div>
      </div>
      <div id="allmap" class="app-content" style="height: 500px;margin-top: 60px"></div>
      <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>


<script type="text/javascript">

  import header1 from "@/components/header1"
  import footers from "@/components/footers"
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../contactUs/wapIndex";

  export default {
    name: 'contactUs',
    components: {header1, footers, wapIndex},
    data() {
      return {
        wapShow: false
      }
    },
    mounted() {
      eventBus.$on("wapShow", (data) => {
        this.wapShow = data;
        if (!this.wapShow) {
          var map = new BMapGL.Map("allmap");
          let icons = 'https://www.scjdst.com/map.png'
          map.centerAndZoom(new BMapGL.Point(106.503294, 29.62063), 16);
          var pt = new BMapGL.Point(106.503323, 29.620032);
          var myIcon = new BMapGL.Icon(icons, new BMapGL.Size(180, 180));
          var AMarkerList = new BMapGL.Marker(pt, {icon: myIcon});
          map.enableScrollWheelZoom(true);
          map.addOverlay(AMarkerList);
        }
      })

    },
    methods: {}

  }
</script>

<style scoped>
  .contactUs-banner {
    width: 100%;
    background-image: url("../../assets/imgs/common/4.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 560px;
    margin-top: 80px;
    background-position: 50% 50%;
    background-color: #F2F4F9;
    overflow: hidden;
  }

  .contactUs-banner .news-detail {
    font-size: 24px;
    letter-spacing: 4px;
    line-height: 2;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    margin-left: 48px;
    margin-top: 56px;
    color: rgba(92, 93, 95, 1);
    animation-duration: 1s;
    opacity: 0;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    animation-name: fadeInUp;
    animation-delay: 1s;
    width: 700px;
  }

  .contactUs-banner .news-title {
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 6px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    margin-left: 48px;
    margin-top: 90px;
    color: #19203B;
    animation-name: fadeInUp;

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
  }

  .contactUs-box1 .box1-title {
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: center;
    margin-top: 60px;
  }

  .contactUs-box1 .box-content {
    margin-top: 40px;
    padding-bottom: 53px;
  }

  .contactUs-box1 .box-content .p1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #19203B;
  }

  .contactUs-box1 .box-content .p2 {
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 42px;
  }

  .contactUs-box2 {
    width: 100%;
    height: 318px;
    background: #F2F4F9;
  }

  .contactUs-box2 .box2-li .li-right .t1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #19203B;
    display: block;
  }

  .contactUs-box2 .box2-li .li-right .line {
    width: 324px;
    height: 1px;
    margin-top: 18px;
    display: block;
    background: #5C5D5F;
  }

  .contactUs-box2 .box2-li .li-right .t2 {
    font-size: 18px;
    display: block;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    text-decoration: none;
    color: #19203B;
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/view/contactUs/index.vue